/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'button/download': {
    width: 23,
    height: 23,
    viewBox: '0 0 23 23',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M5.324 9.064a.75.75 0 00.088 1.057l6.042 5.116 5.933-5.12a.75.75 0 00-.98-1.136L12.2 12.61V2.25h-1.5v10.382L6.38 8.976a.75.75 0 00-1.057.088z" _fill="currentColor"/><path pid="1" d="M4.667 19.25h14" _stroke="currentColor" stroke-width="1.5"/>'
  }
})
